var _defs, _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIllustrationEmptyStateRanking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 96 96",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-2 {\n        fill: #212529;\n      }\n\n      .cls-3 {\n        fill: #7e0386;\n      }\n\n      .cls-4 {\n        fill: none;\n      }\n\n      .cls-5 {\n        fill: #eef0f2;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "background"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 96,
    height: 96
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "illustration"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Elipse_1365",
    "data-name": "Elipse 1365",
    className: "cls-5",
    cx: 48,
    cy: 48,
    r: 38
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M66.05,24.62l-5.79,.89-.89-5.79-28.96,4.44,.89,5.79-5.79,.89c-3.19,.49-5.39,3.49-4.9,6.68l.44,2.9c1.13,7.38,7.61,12.55,14.9,12.36,2.49,4.06,6.9,6.74,11.77,6.97l1.38,8.98-11.58,1.78,.89,5.79,28.96-4.44-.89-5.79-11.58,1.78-1.38-8.98c4.57-1.68,7.98-5.55,9.14-10.17,7.01-1.99,11.65-8.87,10.52-16.25l-.44-2.9c-.49-3.19-3.49-5.39-6.68-4.9Zm-39.21,14.9l-.44-2.9,5.79-.89,1.7,11.06c-3.55-.7-6.47-3.51-7.04-7.28Zm40.54-6.21c.58,3.76-1.37,7.32-4.54,9.05l-1.7-11.06,5.79-.89,.44,2.9Zm-12.49,34.51"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.99,76.85l-1.04-6.78,11.58-1.78-1.24-8.08c-4.74-.35-9.04-2.92-11.61-6.94-.04,0-.09,0-.13,0-7.46,0-13.86-5.43-14.99-12.79l-.44-2.9c-.53-3.47,1.86-6.72,5.32-7.25l5.3-.81-.89-5.79,29.95-4.59,.89,5.79,5.3-.81c3.47-.53,6.72,1.86,7.25,5.32l.44,2.9c1.13,7.4-3.41,14.54-10.6,16.73-1.25,4.6-4.58,8.34-9,10.1l1.24,8.08,11.58-1.78,1.04,6.78-29.94,4.59Zm.1-5.94l.74,4.8,27.97-4.29-.74-4.8-11.58,1.78-1.51-9.88,.38-.14c4.39-1.61,7.69-5.28,8.83-9.82l.07-.28,.28-.08c6.87-1.95,11.23-8.7,10.16-15.7l-.44-2.9c-.45-2.92-3.2-4.93-6.11-4.49l-6.29,.96-.89-5.79-27.97,4.29,.89,5.79-6.29,.96c-2.92,.45-4.93,3.19-4.49,6.11l.44,2.9c1.07,7,7.27,12.16,14.4,11.93h.29s.15,.24,.15,.24c2.45,3.99,6.69,6.51,11.36,6.73l.41,.02,1.51,9.88-11.58,1.78Zm-3.6-23.48l-.7-.14c-3.86-.76-6.85-3.86-7.44-7.69l-.52-3.39,6.78-1.04,1.88,12.26Zm-7.52-10.38l.37,2.4c.49,3.18,2.83,5.79,5.94,6.69l-1.51-9.83-4.8,.74Zm35.49,6.1l-1.88-12.26,6.78-1.04,.52,3.39c.59,3.84-1.34,7.68-4.79,9.57l-.63,.34Zm-.74-11.42l1.51,9.83c2.69-1.79,4.15-4.98,3.66-8.16h0s-.37-2.4-.37-2.4l-4.8,.74Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12.39,
    cy: 44.86,
    r: 5.64
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M12.39,50.99c-3.38,0-6.14-2.75-6.14-6.14s2.75-6.14,6.14-6.14,6.14,2.75,6.14,6.14-2.75,6.14-6.14,6.14Zm0-11.27c-2.83,0-5.14,2.3-5.14,5.14s2.3,5.14,5.14,5.14,5.14-2.3,5.14-5.14-2.3-5.14-5.14-5.14Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "78.71 63.23 81.99 59.67 82.82 64.44 87.21 66.46 82.93 68.71 82.37 73.51 78.9 70.15 74.16 71.09 76.29 66.75 73.93 62.54 78.71 63.23"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M82.74,74.58l-4-3.89-5.48,1.09,2.46-5.01-2.73-4.87,5.53,.79,3.79-4.1,.95,5.5,5.07,2.33-4.94,2.61-.65,5.55Zm-3.68-4.97l2.93,2.85,.48-4.06,3.61-1.91-3.71-1.71-.7-4.02-2.77,3-4.04-.58,2,3.56-1.8,3.67,4-.8Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIllustrationEmptyStateRanking);
export default __webpack_public_path__ + "static/media/illustration_empty-state-ranking.39dd3c4e0ced0233c0d07a75c6403b9d.svg";
export { ForwardRef as ReactComponent };